export enum ComparisonInterval {
  DAYS_7 = '7',
  DAYS_14 = '14',
  DAYS_30 = '30',
}
